<template>
    <div class="con">
<!--        <banComponent :img="info.img" :text0="info.text0" :text1="info.text1"></banComponent>-->
        <div class="banner">
            <img :src="info.img" alt="">
            <div class="text animated fadeInUp">
                <p>{{$t('cy').text0}}</p>
                <p>
                    {{$t('cy').text1}}<br>{{$t('cy').text2}}
                </p>
            </div>
            <div class="scr">
                <span>scrool</span>
                <span></span>
            </div>
        </div>
        <div class="main">
         <div class="one">
          <p class="title">
                {{proInfo.PRONAME}}
          </p>
             <div class="htmlCon" v-html="proInfo.CONTENT">

             </div>
             <div class="info" v-if="proInfo.TITLE2!==''">
                 <!--                 <img :src="`http://junankg.com/upload/${proInfo.SMALLPIC}`" alt="">-->
                 <div class="r">
                     <!--                      <p>{{proInfo.TEXT2}}</p>-->
                     <div style="text-align: right">
                         <span><a :href="proInfo.URL" target="_blank">{{proInfo.TITLE2}}</a></span>
                     </div>
                 </div>
             </div>
         </div>
            <div class="tj">
                <el-carousel class="mainInfo" :interval="5000" arrow="always" height="400px" indicator-position="none">
                    <el-carousel-item v-for="(i,index) in arr" :key="index" style="width:100%;display: flex;flex-direction: row;justify-content: space-between">
                        <div class="item" v-for="(item,idx) in i.a" :key="idx" @click="gotoCy(index,idx)">
                            <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="">
                            <div class="text">
                                <p>{{item.CALLED}}</p>
                                <p>{{$t('cy').text5}}</p>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>

                <el-carousel class="mainInfo mainInfo2" :interval="5000" arrow="always" height="400px" indicator-position="none">
                    <el-carousel-item v-for="(i,index) in arr2" :key="index" style="width:100%;display: flex;flex-direction: row;justify-content: space-between">
                        <div class="item" v-for="(item,idx) in i.a" :key="idx" @click="gotoCy(index,idx)">
                            <img :src="`http://junankg.com/upload/${item.PICURL}`" alt="">
                            <div class="text">
                                <p>{{item.CALLED}}</p>
                                <p>{{$t('cy').text5}}</p>
                            </div>
                        </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
        <foot-Component></foot-Component>
    </div>
</template>

<script>
    import  banComponent from '../components/tbanner'
    import footComponent from '../components/foot'
    import {getProductsInfo,getProductstypeUrl2} from '../util/lang'
    export default {
        name: "proInfo",
        data(){
            return{
                arr:[],
                arr2:[],
                info:{
                    img:require('../assets/cy/ban.png'),
                    text0:'产业布局',
                    text1:'君行正道  安积德义'
                },
                proInfo:{}
            }
        },
        components:{banComponent,footComponent},
        mounted(){
            this.getInfo(this.$route.query.id)
            if( this.$i18n.locale === 'en'){
                this.getPro('47')
            }else{
                this.getPro('42')
            }
            let n=parseInt(this.$route.query.index)
            if(n===0){
                this.info.img=require('../assets/cy/ban.png')
            }else if(n===1){
                this.info.img=require('../assets/cy/sy.jpg')
            }else if(n===2){
                this.info.img=require('../assets/cy/tz.jpg')
            }else{
                this.info.img=require('../assets/cy/jz.jpg')
            }
        },
        methods:{
            gotoCy(i,n){
                if(i>=1){
                    n=i+1+n
                }
                this.$router.push({path:'/cy',query:{index2:n}})
            },
            getInfo(id){
                const url = `${getProductsInfo(this.$i18n.locale,id)}`
                this.$axios.get(url).then(res => {
                    this.proInfo=res.data.proarr
                    console.log(this.proInfo)
                })
            },
            getPro(id){
                this.$nextTick(()=>{
                    const url = `${getProductstypeUrl2(this.$i18n.locale,id)}`
                    this.$axios.get(url).then(res => {
                        for(let i=0;i<res.data.length;i+=2){
                            this.arr.push({a:res.data.slice(i,i+2)})
                        }
                        for(let i=0;i<res.data.length;i+=1){
                            this.arr2.push({a:res.data.slice(i,i+1)})
                        }
                    })
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
.con{
    width:100%;
    .banner{
        width:100%;
        position: relative;
        height:100vh;
        overflow: hidden;
        img{
            width:100%;
            height:100%;
            object-fit: cover;
            display: block;
        }
        .text{
            position: absolute;
            left:10%;
            width:70%;
            top:40%;
            color:white;
            p:nth-child(1){
                font-size: 50px;
                font-weight: bold;
            }
            p:nth-child(2){
                font-family: normal;
                font-weight: lighter;
                margin-top: 40px;
                line-height: 30px;
                font-size: 14px;
            }
        }
        .scr{
            width:10%;
            position: absolute;
            left:45%;
            bottom:0;
            z-index: 1000;
            height:120px;
            text-align: center;
            text-transform: uppercase;
            display: flex;
            flex-direction: column;
            justify-content: center;
            span:nth-child(1){
                color:white;
                padding-bottom: 10px;
                font-size: 12px;
            }
            span:nth-child(2){
                width:1px;
                height:100px;
                background-color: rgba(255,255,255,.2);
                position: relative;
                margin-left: 50%;
            }
            span:nth-child(2)::before{
                content:'';
                display: inline-block;
                width:1px;
                height:20px;
                position: absolute;
                top:30%;
                left:0;
                animation: runa 2s infinite ease;
                background-color: white;
            }
            @keyframes runa {
                from{
                    top:0;
                }
                to{
                    top:100%;
                }
            }
        }

    }
    .main{
        width:100%;
        .one{
            width:1280px;
            margin: 60px auto;
            .title{
                width:50%;
                color:#444546;
                font-size: 22px;
                font-weight: bold;
                border-bottom: 1px solid rgba(130, 130, 130, .3);
                padding-bottom: 20px;
                position: relative;
                margin-left: 5%;
            }
            .title::before{
                position: absolute;
                left:0;
                bottom:0;
                content:'';
                display: inline-block;
                width:30%;
                height:1px;
                background-color: #0068B7;
            }
            .info{
                width:95%;
                display: flex;
                flex-direction: row;
                margin-left: 5%;
                .r{
                    width:100%;
                    text-align: right;
                    font-size: 14px;
                    line-height: 30px;
                    p{
                        padding-top: 120px;
                    }
                    span{
                        display: inline-block;
                        padding: 2px 15px;
                        background-color: #0068B7;
                        border-radius: 10px;
                        margin-top: 20px;
                        a{
                            color:white;
                        }
                    }
                }
            }
            .htmlCon{
                width:95%;
                margin-top: 60px;
                line-height: 30px;
                font-size: 14px;
                margin-left: 5%;
                overflow: hidden;
            }
        }
        .tj{
            width:100%;
            background-color: #F7F7F7;
            padding: 80px 0;
            .mainInfo{
                width:1280px;
                margin: 0 auto;
                .item{
                    overflow: hidden;
                    width:48%;
                    cursor: pointer;
                    position: relative;
                    .text{
                        position: absolute;
                        left:0;
                        top:-100%;
                        background-color: rgba(0, 104, 183, .7);
                        width:100%;
                        height:100%;
                      text-align: center;
                        transition: all 1s;
                        color:white;
                        p:nth-child(1){
                            font-size: 25px;
                            font-weight: bold;
                            padding-top: 200px;
                        }
                        p:nth-child(2){
                            margin-top: 30px;
                            font-size: 14px;
                        }
                    }
                }
                .item:hover{
                    .text{
                        top:0;
                    }
                }
            }
            .mainInfo2{
                display: none;
            }
        }
    }
    @media screen and (max-width:1280px){
        .main{
            .one{
              .htmlCon{
                  margin-left: 2.5%;
              }
            }
        }
    }
    @media screen and (max-width:1279px){
        .banner{
            .text{
                width:80%;
                top:30%;
            }
        }
        .main{
            .one{
                width:95%;
                margin-left: 2.5%;
                .title{
                    width:80%;
                    margin-left: 10%;
                    font-size: 20px;
                }
                .info{
                    flex-direction: column;
                    img{
                        object-fit: contain;
                    }
                    .r{
                        p{
                            padding-top: 0;
                        }
                    }
                }
                .htmlCon{
                    margin-left: 2.5%;
                    margin-top: 30px;
                }
            }
            .tj{
                .mainInfo{
                    display: none;
                    width:95%;
                    margin-left: 2.5%;
                    .item{
                        width:100%;
                        img{
                            width:100%;
                            height:100%;
                            object-fit: cover;
                        }
                    }
                }
                .mainInfo2{
                    display: block;
                }
            }
        }
    }
}
</style>
<style scoped>
    @media screen and (max-width:450px){
        .htmlCon >>>  table{
            width:100%;
            word-break: break-all;
        }
        .htmlCon >>>  table img{
        width:100px;
        }
        .htmlCon >>>  div img{
            width:100%;
            height:200px;
        }
        .htmlCon >>>  p img{
            width:100%;
            object-fit: contain;
        }
    }
</style>